// Tag management utility functions
export const initializeTags = () => {
  const existingTags = JSON.parse(sessionStorage.getItem('usedTags') || '[]')
  const defaultTags = ['name', 'phone']

  // Add default tags if not already present
  const updatedTags: any = Array.from(new Set([...defaultTags, ...existingTags]))
  sessionStorage.setItem('usedTags', JSON.stringify(updatedTags))
  return updatedTags
}

export const addTagToSession = (tagName: any) => {
  if (!tagName || tagName.trim() === '') return false

  const normalizedTag = tagName.trim().toLowerCase()
  const existingTags = JSON.parse(sessionStorage.getItem('usedTags') || '[]')
  const normalizedExistingTags = existingTags.map((tag: any) => tag.toLowerCase())

  if (normalizedExistingTags.includes(normalizedTag)) {
    return false // Tag already exists
  }

  const updatedTags = [...existingTags, tagName.trim()]
  sessionStorage.setItem('usedTags', JSON.stringify(updatedTags))
  return true
}

export const removeTagFromSession = (tagName: any) => {
  if (!tagName) return

  const existingTags = JSON.parse(sessionStorage.getItem('usedTags') || '[]')
  const updatedTags = existingTags.filter((tag: any) => tag.toLowerCase() !== tagName.toLowerCase())
  sessionStorage.setItem('usedTags', JSON.stringify(updatedTags))
}

export const isTagAvailable = (tagName: any, currentTag = '') => {
  if (!tagName || tagName.trim() === '') return true

  const normalizedTag = tagName.trim().toLowerCase()
  const normalizedCurrentTag = currentTag.toLowerCase()

  // If it's the same as current tag, it's available
  if (normalizedTag === normalizedCurrentTag) return true

  const existingTags = JSON.parse(sessionStorage.getItem('usedTags') || '[]')
  const normalizedExistingTags = existingTags.map((tag: any) => tag.toLowerCase())

  return !normalizedExistingTags.includes(normalizedTag)
}
